import React, { Component } from 'react';
import { connect } from "react-redux";
import { loginClicked, profilePicClicked } from '../../../redux/actions';

import './profilePic.css';

import Loading from '../loading/loading'

class ProfilePic extends Component {
  render() {
    const user = this.props.employee
    const { profilePic, loggedIn } = user
    if(this.props.size === 'small') {
      if(!user || !loggedIn) { // user not logged in = open login screen
        return <p className='mdi mdi-account-outline' onClick={this.props.clickable ? () => this.props.loginClicked(true) : ''}></p>
      } else if(loggedIn && !profilePic) { // There is a user, but no picture = open profile
        return <p className='mdi mdi-account avatar-small' onClick={this.props.clickable ? () => this.props.profilePicClicked(true) : ''}></p>
      } else { // user and picture
        return <img className='avatar-small fill' src={profilePic} onClick={this.props.clickable ? () => this.props.profilePicClicked(true) : ''}/>
      }
    } else if(this.props.size === 'big' || 'medium') {
      if(profilePic && profilePic === 'loading') {
        return <div className={`avatarWrap-${this.props.size}`}><div className={`avatar avatar-${this.props.size} mdi`}><Loading /></div></div>
      } else if(profilePic) {
        return <div className={`avatarWrap-${this.props.size}`}><img className={`avatar avatar-${this.props.size} fill`} src={profilePic} /></div>
      } else {
        return <div className={`avatarWrap-${this.props.size}`}><div className={`avatar avatar-${this.props.size} mdi mdi-account`} /></div>
      }
    }

  }
}

export default connect(null, { loginClicked, profilePicClicked })(ProfilePic);
